'use client';

import { useServerStatus } from '@/hooks/useServerStatus';
import { OctagonAlert } from 'lucide-react';
import { useTranslations } from 'next-intl';

export function ServerStatusBanner() {
  const { online, isLoading, isError } = useServerStatus();
  const t = useTranslations('ServerStatus');
  const serverDown = isError || !online;

  if (isLoading || !serverDown) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center gap-3 border-b border-red-300 bg-red-50 px-4 py-2 text-sm text-red-950"
    >
      <OctagonAlert className="size-4 shrink-0 text-red-600" />
      <span className="flex-1">{t('down')}</span>
    </div>
  );
}
